<template>
  <JobApplicationSection ref="jobApplication"></JobApplicationSection>
</template>

<script>
  import JobApplicationSection from "./JobApplicationSection.vue";
  import BeforeRouteEnter from "./BeforeRouteEnter.js";

  export default {
    name: "JobApplicationWrapper",
    components: {
      JobApplicationSection,
    },
    beforeRouteEnter: BeforeRouteEnter,
  };
</script>
